<div class="app flex-column p-relative overflow-hidden">
    <mat-toolbar class="header flex j-space-between a-center">
        <div class="flex">
            <div class="logo" data-testid="app-title">JCall Tracker</div>
            <div>{{ pageName() | uppercase}}</div>
        </div>
        @if (authService.isAdmin()) {
            <app-common-dropdown class="selector" [noneOption]="false" [label]="'Компания'" [service]="companySelectorService" [formCtrl]="companyControl" data-testid="app-dropdown-company"/>
        }
        <app-time-zone class="selector"/>

        <app-menu [isAuth]="authService.loggedIn()" (logoutEvent)="logout()" [pageName]="pageName"/>
    </mat-toolbar>
    <main class="flex flex-1 overflow-auto" data-testid="app-content">
        <div class="main-content flex-1 overflow-auto">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
